/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S8_Body_PostInputs */

const tr_servis_s8_body_post = /** @type {(inputs: Servis_S8_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Kullanıcı'yı ve KVKK Madde 12/5 uyarınca Kişisel Verileri Koruma Kurulu'nu bilgilendirir. Olay raporunda etki alanı, alınan önlemler ve eylem planı yer alır.`)
};

const en_servis_s8_body_post = /** @type {(inputs: Servis_S8_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` of the date the incident is detected. The incident report states the scope of impact, the measures taken and the action plan.`)
};

const de_servis_s8_body_post = /** @type {(inputs: Servis_S8_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` ab dem Zeitpunkt der Feststellung des Vorfalls den Nutzer sowie gemäß KVKK Madde 12/5 den Kişisel Verileri Koruma Kurulu (türkischer Ausschuss zum Schutz personenbezogener Daten). Der Vorfallbericht enthält den betroffenen Bereich, die getroffenen Maßnahmen und den Aktionsplan.`)
};

const ru_servis_s8_body_post = /** @type {(inputs: Servis_S8_Body_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` с момента выявления инцидента. В отчете об инциденте указываются область воздействия, принятые меры и план действий.`)
};

/**
* | output |
* | --- |
* | "of the date the incident is detected. The incident report states the scope of impact, the measures taken and the action plan." |
*
* @param {Servis_S8_Body_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s8_body_post = /** @type {((inputs?: Servis_S8_Body_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S8_Body_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s8_body_post(inputs)
	if (locale === "de") return de_servis_s8_body_post(inputs)
	if (locale === "ru") return ru_servis_s8_body_post(inputs)
	return tr_servis_s8_body_post(inputs)
});